import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Undo = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M7.20769 18.5001H15.0799C17.7958 18.5001 20 16.1924 20 13.3491C20 10.5058 17.7958 8.19824 15.0799 8.19824H4.25562'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.5191 10.7745L4 8.13726L6.5191 5.5'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.50562 8.19824C3.50562 7.78403 3.8414 7.44824 4.25562 7.44824H15.0799C18.242 7.44824 20.75 10.1244 20.75 13.3491C20.75 16.5739 18.242 19.2501 15.0799 19.2501H7.20769C6.79347 19.2501 6.45769 18.9143 6.45769 18.5001C6.45769 18.0858 6.79347 17.7501 7.20769 17.7501H15.0799C17.3495 17.7501 19.25 15.811 19.25 13.3491C19.25 10.8873 17.3495 8.94824 15.0799 8.94824H4.25562C3.8414 8.94824 3.50562 8.61246 3.50562 8.19824Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.03714 4.95766C7.33667 5.24377 7.34755 5.71852 7.06144 6.01804L5.03717 8.13726L7.06144 10.2565C7.34755 10.556 7.33667 11.0308 7.03714 11.3169C6.73762 11.603 6.26287 11.5921 5.97676 11.2926L3.45766 8.65531C3.18078 8.36544 3.18078 7.90909 3.45766 7.61922L5.97676 4.98196C6.26287 4.68243 6.73762 4.67155 7.03714 4.95766Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
